<template>
  <div class="client-coupons">
    <ag-table :data-source-api="getAllClientCoupon" :grid-options="gridOptions" :permissions="permissions" :rtl="false"
      :is-entities-response="false" />
  </div>
</template>

<script>
import { RepositoryFactory } from '../../loyalty-repositories/loyaltyRepositoryFactory';
import AgTable from '../../../shared/shared-components/ag-grid/AgTableServerSide.vue';
import utilities from "@/app/shared/utilities/index";

const clientsRepo = RepositoryFactory.get('clientsRepository');
export default {
  name: "ClientCoupons",
  components: {
    AgTable,
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      permissions: {}
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: 'اسم الكوبون',
          field: 'coupon.name',
          filter: 'agTextColumnFilter',
          width: 200,
          sortable: false
        },
        {
          headerName: 'اسم المستخدم',
          field: 'client.name',
          filter: 'agTextColumnFilter',
          width: 200,
          sortable: false
        },
        {
          headerName: 'الكود',
          field: 'coupon.code',
          filter: 'agTextColumnFilter',
          width: 200,
          sortable: false
        },
        {
          headerName: 'عدد النقاط',
          field: 'couponPoints',
          filter: 'agNumberColumnFilter',
          width: 200,
          sortable: true
        },
        {
          headerName: 'تاريخ الاضافة',
          field: 'createdAt',
          width: 200,
          sortable: false,
          valueFormatter: (params) =>
            params.data.createdAt
              ? utilities.formatDate(params.data.createdAt, 'yyyy-MM-DD')
              : '-'
        },
        {
          headerName: 'تاريخ الإلغاء',
          field: 'reversedAt',
          width: 200,
          sortable: false,
          valueFormatter: (params) =>
            params.data.reversedAt
              ? utilities.formatDate(params.data.reversedAt, 'yyyy-MM-DD')
              : '-'
        },
      ];
    },
    async getAllClientCoupon(query) {
      const id = this.$route.params.id;
      return await clientsRepo.fetchClientCoupon(query, id);
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
};
</script>